export const getWrapperStyle = (depth, isCurrent, isMatched) => ({
    paddingLeft: depth * 16,
    backgroundColor: isCurrent ? '#fff2ab' : isMatched ? '#f3f3f3' : undefined,
});

export const toggleButtonStyle = {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
};

export const arrayObjectStyle = {
    marginLeft: 4,
    color: '#0000ff'
};

export const keyNameStyle = {
    marginLeft: 6,
    color: '#000'
};

export const keyStyle = {
    color: '#000'
};